import { motion } from "framer-motion";

const easeOut = [0.16, 1, 0.3, 1];

/*
 * NOTE (SEO / prerender):
 * These wrappers animate ONLY the `y` transform, never opacity. Cards must
 * be visually present the moment the page loads so Googlebot, GPTBot and
 * every prerender / Lighthouse crawler see them in the rendered screenshot
 * without waiting for scroll or animation completion. We also animate on
 * mount (not `whileInView`) so headless browsers that never scroll still
 * transition to the final state.
 */

export function Reveal({ children, delay = 0, y = 20, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ y }}
      animate={{ y: 0 }}
      transition={{ duration: 0.55, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "" }) {
  return <div className={className}>{children}</div>;
}

export function StaggerItem({ children, className = "", y = 16 }) {
  return (
    <motion.div
      className={className}
      initial={{ y }}
      animate={{ y: 0 }}
      transition={{ duration: 0.45, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line hero reveal. `lines` = array of strings.
export function LineReveal({ lines, className = "", accentIndex = -1 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${i === accentIndex ? "text-primary" : ""}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: 0.15 + i * 0.12, ease: easeOut }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
